import { obterFamiliasAsync } from "../../services/familiaService";

const atualizarFamilias = async ({ commit }) => {
    const familias = await obterFamiliasAsync();
    commit('atualizarFamilias', familias);
}

const atualizarFamilia = ({ commit }, familia) => {
    commit('atualizarFamilia', familia);
}

export default {
    atualizarFamilias,
    atualizarFamilia
}